import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import Loadable from 'react-loadable'

import Loader from 'components/LayoutComponents/Loader'
import IndexLayout from 'layouts'
import NotFoundPage from 'pages/404'

const loadable = loader =>
  Loadable({
    loader,
    delay: false,
    loading: () => <Loader />,
  })

const routes = [
  // System Pages
  {
    key: 0,
    path: '/user/login',
    component: loadable(() => import('pages/user/login')),
    exact: true,
  },
  {
    key: 1,
    path: '/user/forgot',
    component: loadable(() => import('pages/user/forgot')),
    exact: true,
  },
  {
    key: 2,
    path: '/user/signup',
    component: loadable(() => import('pages/user/signup')),
    exact: true,
  },

  // user pages
  {
    key: 3,
    path: '/profile',
    component: loadable(() => import('pages/profile')),
    exact: true,
  },

  {
    key: 4,
    path: '/subscription/pricing',
    component: loadable(() => import('pages/pricing-table')),
  },

  // Dashboards
  {
    key: 5,
    path: '/dashboard/alpha',
    component: loadable(() => import('pages/dashboard/alpha')),
  },

  // platform catalogs
  {
    key: 6,
    path: '/platform/products',
    component: loadable(() => import('pages/catalog/product')),
  },

  // companies
  {
    key: 7,
    path: '/platform/company',
    component: loadable(() => import('pages/catalog/company')),
  },

  // platform users
  {
    key: 8,
    path: '/platform/users',
    component: loadable(() => import('pages/catalog/users')),
  },

  // company users
  {
    key: 9,
    path: '/company/users',
    component: loadable(() => import('pages/catalog/users')),
  },

  // company groups
  {
    key: 10,
    path: '/company/groups',
    component: loadable(() => import('pages/catalog/groups')),
  },

  // project projects
  {
    key: 11,
    path: '/project/projects',
    component: loadable(() => import('pages/catalog/project')),
  },

  // project sites
  {
    key: 12,
    path: '/project/sites',
    component: loadable(() => import('pages/catalog/site')),
  },

  // project devices
  {
    key: 13,
    path: '/project/devices',
    component: loadable(() => import('pages/catalog/device')),
  },

  // project tags
  {
    key: 14,
    path: '/project/tags',
    component: loadable(() => import('pages/catalog/tag')),
  },

  {
    key: 15,
    path: '/analysis',
    component: loadable(() => import('pages/analysis')),
    exact: true,
  },
]

class Router extends React.Component {
  render() {
    const { history } = this.props
    return (
      <ConnectedRouter history={history}>
        <IndexLayout>
          <Switch>
            <Route exact path="/" render={() => <Redirect to="/subscription/pricing" />} />
            {routes.map(route => (
              <Route
                path={route.path}
                component={route.component}
                key={route.key}
                exact={route.exact}
              />
            ))}
            <Route component={NotFoundPage} />
          </Switch>
        </IndexLayout>
      </ConnectedRouter>
    )
  }
}

export default Router
